enum ESeverityLevel {

    ERROR   = 0,
    WARNING = 1,
    INFO    = 2,

}

export default ESeverityLevel;
